module.exports = __webpack_public_path__ + "assets/views/00_common/tab_bottom_line_bg.png";